import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { formatDate } from "../../../../utils/dateUtils";

function ListadoAjustesInventario() {
  const { user } = useContext(AuthContext);
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_ARTICULOS_AJUSTES_INV = import.meta.env.VITE_URL_ARTICULOS_AJUSTES_INV;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_AJUSTES_INVENTARIO = import.meta.env.VITE_URL_AJUSTES_INVENTARIO;
  const AREAS_GENERAL = import.meta.env.VITE_AREAS_GENERAL;

  const [areas, setAreas] = useState([]);
  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState("");
  const [selectedArea, setselectedArea] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  // Detail modal for showing adjustment details
  const [modalDetail, setModalDetail] = useState(false);
  const toggleDetail = () => setModalDetail(!modalDetail);
  const [selectedAdjustment, setSelectedAdjustment] = useState(null);
  const [adjustmentDetails, setAdjustmentDetails] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(URL_AJUSTES_INVENTARIO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAjusteInv = response.data;
        // Array para pagination
        let arrayTabla = allAjusteInv
          .sort((a, b) => (a.idAjusteInv < b.idAjusteInv ? 1 : -1))
          .map((a) => {
            if((user.areas == AREAS_GENERAL)){
            return {
              _id: a._id,
              numero: a.idAjustesInventario,
              fecha: a.fecha,
              observaciones: a.observaciones,
              total: a.total,
              area: a.areas[0].name,
              idArea: a.areas[0]._id,
              autorizado:a.autorizado,
              user: a.user[0].nombre + " " + a.user[0].apellido
            }} else if(user.areas == a.areas[0]._id){
              return {
                _id: a._id,
                numero: a.idAjustesInventario,
                fecha: a.fecha,
                observaciones: a.observaciones,
                total: a.total,
                area: a.areas[0].name,
                idArea: a.areas[0]._id,
                autorizado:a.autorizado,
                user: a.user[0].nombre + " " + a.user[0].apellido
              }
            }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user]);

  // Load adjustment details
  const loadAdjustmentDetails = async (adjustmentId) => {
    try {
      const response = await axios.get(`${URL_ARTICULOS_AJUSTES_INV}Ajuste/${adjustmentId}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });
      
      const details = response.data.map((item) => ({
        _id: item._id,
        articulo: item.articulos[0].codigo + " - " + item.articulos[0].nombre,
        cantidad: item.cantidad,
        color: item.colores ? item.colores[0]?.name || "N/A" : "N/A",
        talla: item.tallas ? item.tallas[0]?.name || "N/A" : "N/A",
        articuloProporcionId: item.articulosProporcion ? item.articulosProporcion[0]?._id || "N/A" : "N/A",
        inventarioId: item.inventarios ? item.inventarios[0]?._id || "N/A" : "N/A",
      }));
      
      setAdjustmentDetails(details);
    } catch (error) {
      console.error("Error loading adjustment details:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al cargar los detalles del ajuste",
      });
    }
  };

  // Show adjustment details in modal
  const showAdjustmentDetails = (adjustment) => {
    setSelectedAdjustment(adjustment);
    loadAdjustmentDetails(adjustment._id);
    toggleDetail();
  };

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.area,
          new Intl.NumberFormat("en-US").format(a.total),
          a.autorizado,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ajustes Inventario`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        ["Numero", "Fecha","Observaciones", "Almacen", "Cantidad", "Autorizado"],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    window.open(doc.output("bloburl"), "_blank");
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea) 
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Observaciones: a.observaciones,
          Almacen: a.area,
          Cantidad: a.total,
          Autorizado: a.autorizado,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};
    option.fileName = "ListadoAjustesInventario";
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAjustesInventario",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen",
          "Cantidad",
          "Autorizado",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Observaciones",
          "Almacen",
          "Cantidad",
          "Autorizado",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedArea == 0 || selectedArea == a.idArea)
      ) {
        return [
          a.numero,
          a.fecha,
          a.observaciones,
          a.area,
          new Intl.NumberFormat("en-US").format(a.total),
          a.autorizado,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape","mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Ajustes Inventario`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        ["Numero", "Fecha", "Observaciones", "Almacen", "Cantidad", "Autorizado"],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Ajustes Inventario",
          email: mailTo,
          fileName: "ListadoAjustesInventario.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${import.meta.env.VITE_TAMANO_LOGO_MAIL}" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${import.meta.env.VITE_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Ajustes Inventario.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${import.meta.env.VITE_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${import.meta.env.VITE_LINK_SISTEMA}Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  // Enhanced PDF with detailed breakdown including colors and sizes
  async function PDFOC(numero, fecha, observaciones, area, total, idPDFOC) {
    try {
      const response = await axios.get(`${URL_ARTICULOS_AJUSTES_INV}Ajuste/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      });

      let allArticulos = response.data;
      
      // Enhanced data mapping with colors, sizes, and proportions
      let arrayTabla = allArticulos
        .map((a) => {
          return {
            id: a._id,
            articulo: a.articulos[0].codigo + " - " + a.articulos[0].nombre,
            cantidad: a.cantidad,
            color: a.colores ? a.colores[0]?.name || "N/A" : "N/A",
            talla: a.tallas ? a.tallas[0]?.name || "N/A" : "N/A",
            articuloProporcion: a.articulosProporcion ? a.articulosProporcion[0]?._id || "N/A" : "N/A",
            inventario: a.inventarios ? a.inventarios[0]?._id || "N/A" : "N/A",
          };
        })
        .filter(function (el) {
          return el != null;
        });

      let dataFinal = Object.values(arrayTabla);

      // Create detailed data for PDF with colors and sizes
      const data = dataFinal.map((a) => {
        return [
          a.articulo,
          a.color,
          a.talla,
          new Intl.NumberFormat("en-US").format(a.cantidad),
        ];
      });

      const dataPDF = Object.values(data);
      const dataPDFLimpia = dataPDF.filter(function (el) {
        return el != null;
      });

      // Calculate totals by color and size
      const colorTotals = {};
      const sizeTotals = {};
      
      dataFinal.forEach(item => {
        if (item.color !== "N/A") {
          colorTotals[item.color] = (colorTotals[item.color] || 0) + item.cantidad;
        }
        if (item.talla !== "N/A") {
          sizeTotals[item.talla] = (sizeTotals[item.talla] || 0) + item.cantidad;
        }
      });

      const doc = new jsPDF("landscape", "mm", "a4", true);
      
      // Header
      var img = new Image();
      img.src = "Logo-Sistemify-PDF.png";
      doc.addImage(img, "png", 230, 30, 45, 15);
      var img2 = new Image();
      img2.src = "logoInstitucion.png";
      doc.addImage(img2, "png", 140, 15, 38, 18);
      
      doc.setFontSize(16);
      doc.text(`Ajuste # ${numero}`, 20, 20);
      doc.setFontSize(12);
      doc.text(`Fecha ${fecha}`, 20, 25);
      doc.text(`Almacen ${area}`, 20, 30);
      doc.text(`Piezas ${new Intl.NumberFormat("en-US").format(total)}`, 20, 35);
      doc.text(`Observaciones ${observaciones}`, 20, 40);

      // Main articles table with colors and sizes
      doc.autoTable({
        head: [["Articulo", "Color", "Talla", "Cantidad"]],
        body: dataPDFLimpia,
        startY: 50,
        styles: { fontSize: 8 },
        headStyles: { fillColor: [66, 139, 202] },
        columnStyles: {
          0: { cellWidth: 100 },
          1: { cellWidth: 30, halign: 'center' },
          2: { cellWidth: 25, halign: 'center' },
          3: { cellWidth: 30, halign: 'right' }
        }
      });

      let currentY = doc.lastAutoTable.finalY + 10;

      // Summary by colors
      if (Object.keys(colorTotals).length > 0) {
        doc.setFontSize(12);
        doc.text("Resumen por Colores:", 20, currentY);
        currentY += 5;

        const colorData = Object.entries(colorTotals).map(([color, quantity]) => [
          color,
          new Intl.NumberFormat("en-US").format(quantity)
        ]);

        doc.autoTable({
          head: [["Color", "Cantidad"]],
          body: colorData,
          startY: currentY,
          styles: { fontSize: 8 },
          headStyles: { fillColor: [92, 184, 92] },
          columnStyles: {
            0: { cellWidth: 50, halign: 'center' },
            1: { cellWidth: 30, halign: 'right' }
          }
        });

        currentY = doc.lastAutoTable.finalY + 10;
      }

      // Summary by sizes
      if (Object.keys(sizeTotals).length > 0) {
        doc.setFontSize(12);
        doc.text("Resumen por Tallas:", 20, currentY);
        currentY += 5;

        const sizeData = Object.entries(sizeTotals).map(([size, quantity]) => [
          size,
          new Intl.NumberFormat("en-US").format(quantity)
        ]);

        doc.autoTable({
          head: [["Talla", "Cantidad"]],
          body: sizeData,
          startY: currentY,
          styles: { fontSize: 8 },
          headStyles: { fillColor: [240, 173, 78] },
          columnStyles: {
            0: { cellWidth: 50, halign: 'center' },
            1: { cellWidth: 30, halign: 'right' }
          }
        });

        currentY = doc.lastAutoTable.finalY + 10;
      }

      // Total footer
      doc.setFontSize(14);
      doc.setFont(undefined, 'bold');
      doc.text(`Total General: ${new Intl.NumberFormat("en-US").format(total)} piezas`, 20, currentY);

      window.open(doc.output("bloburl"), "_blank");
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al generar el PDF detallado",
      });
    }
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: false },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Usuario", field: "user", sortable: true },
    { name: "Cantidad", field: "total", sortable: true },
    { name: "Autorizado", field: "autorizado", sortable: true },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.numero.toString().includes(search) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.user.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.total.toString().includes(search) ||
          comment.autorizado.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }
    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }
    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "total" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "total" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedArea,
  ]);

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_AJUSTES_INVENTARIO}/${id}`;
    const URL_AUTORIZADO_HIJO = `${URL_ARTICULOS_AJUSTES_INV}/autorizado/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .patch(
                URL_AUTORIZADO_HIJO,
                {
                  ajustesInventario: id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
          }).then(()=>{
            Swal.fire("Good job!", "Autorizado con exito", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ajustesInventario ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {user.ajustesInventario ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/AjustesInventarioCreate"
                >
                  Nuevo Ajuste
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Ajuste
                </Button>
              )}
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          {/* Mail Modal */}
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Ajustes Inventario</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          {/* Detail Modal */}
          <Modal size="lg" isOpen={modalDetail} toggle={toggleDetail}>
            <ModalHeader toggle={toggleDetail}>
              <h4>
                Detalles del Ajuste {selectedAdjustment?.numero} - {selectedAdjustment?.area}
              </h4>
            </ModalHeader>
            <ModalBody>
              {selectedAdjustment && (
                <div>
                  <Row className="mb-3">
                    <Col md={6}>
                      <strong>Fecha:</strong> {selectedAdjustment.fecha}
                    </Col>
                    <Col md={6}>
                      <strong>Usuario:</strong> {selectedAdjustment.user}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <strong>Total Piezas:</strong> {new Intl.NumberFormat("en-US").format(selectedAdjustment.total)}
                    </Col>
                    <Col md={6}>
                      <strong>Autorizado:</strong> 
                      <span className={`badge ${selectedAdjustment.autorizado === 'Si' ? 'badge-success' : 'badge-warning'} ml-2`}>
                        {selectedAdjustment.autorizado}
                      </span>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <strong>Observaciones:</strong> {selectedAdjustment.observaciones}
                    </Col>
                  </Row>
                  
                  <h5>Artículos Ajustados</h5>
                  <Table size="sm" striped>
                    <thead>
                      <tr>
                        <th>Artículo</th>
                        <th>Color</th>
                        <th>Talla</th>
                        <th>Cantidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      {adjustmentDetails.map((detail, index) => (
                        <tr key={index}>
                          <td>{detail.articulo}</td>
                          <td>
                            <span className="badge badge-info">{detail.color}</span>
                          </td>
                          <td>
                            <span className="badge badge-secondary">{detail.talla}</span>
                          </td>
                          <td className="text-right">
                            <strong>{new Intl.NumberFormat("en-US").format(detail.cantidad)}</strong>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="secondary" onClick={toggleDetail}>
                Cerrar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Ajustes de Inventario</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Almacén</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  setselectedArea(e.target.value);
                }}
              >
                <option value="">Todos los Almacenes</option>
                {areas
                  .filter((area) => 
                    user.areas === AREAS_GENERAL || 
                    user.areas === area._id
                  )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((area) => (
                    <option key={area._id} value={area._id}>
                      {area.name}
                    </option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                return (
                  <tr key={a._id}>
                    <td>{a.numero}</td>
                    <td>{formatDate(a.fecha)}</td>
                    <td>{a.observaciones}</td>
                    <td>{a.area}</td>
                    <td>{a.user}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.total)}</td>
                    <td>
                      <span 
                        className={`badge ${a.autorizado === 'Si' ? 'badge-success' : 'badge-warning'}`}
                      >
                        {a.autorizado}
                      </span>
                    </td>
                    <td>
                      {user.ajustesInventario ? (
                        <div>
                          {/* View Details Button */}
                          <Button
                            size="sm"
                            className="btn mr-1"
                            color="info"
                            onClick={() => showAdjustmentDetails(a)}
                            title="Ver Detalles"
                          >
                            <i className="fas fa-eye"></i>
                          </Button>
                          
                          {/* PDF Button */}
                          <Button
                            size="sm"
                            className="btn mr-1"
                            color="danger"
                            onClick={(e) => PDFOC( 
                              a.numero,
                              a.fecha,
                              a.observaciones,
                              a.area,
                              a.total,
                              a._id 
                            )}
                            title="Generar PDF Detallado"
                          >
                            <i className="far fa-file-pdf"></i>
                          </Button>
                          
                          {/* Authorization Button */}
                          {a.autorizado === "No" && user.autorizarAjustesInventario ? (
                            <Button
                              size="sm"
                              color="primary"
                              onClick={(e) => autorizar(a._id)}
                              title="Autorizar Ajuste"
                            >
                              <i className="fas fa-thumbs-up"></i>
                            </Button>
                          ) : null}
                        </div>
                      ) : null}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="alert alert-warning">
            <h4>Acceso Denegado</h4>
            <p>No tienes permisos para acceder a esta sección.</p>
          </div>
        </div>
      )}
      <br />
      {loader}
    </>
  );
}

export default ListadoAjustesInventario;